<template>
  <div id="extractionConfirmationModal">
    <div>
      <h2
        :id="'extractionConfirmationModalTitle'"
        class="font-bitter text-2xl font-bold mb-4">
        Great news!
      </h2>
      <p class="mb-4">
        We found the following information in your manuscript template.
      </p>
      <div
        id="pnl-extractionConfirmationModal-title"
        class="w-full block box-border relative mb-3"
        v-if="extractedTitle">
        <div class="w-[8.333%] table-cell box-border align-top text-center pr-3">
          <SuccessIcon class="text-royal-blue-100">
          </SuccessIcon>
        </div>
        <div class="w-[91.666%] table-cell align-top box-border">
          Article title
        </div>
      </div>
      <div
        id="pnl-extractionConfirmationModal-abstractTitle"
        class="w-full block box-border relative mb-3"
        v-if="extractedAbstract">
        <div class="w-[8.333%] table-cell box-border align-top c-fixed text-center pr-3">
          <SuccessIcon class="text-royal-blue-100">
          </SuccessIcon>
        </div>
        <div class="w-[91.666%] table-cell align-top box-border">
          Article abstract
        </div>
      </div>
      <div
        id="pnl-extractionConfirmationModal-authors"
        class="w-full block box-border relative mb-3"
        v-if="extractedAuthors">
        <div class="w-[8.333%] table-cell box-border align-top c-fixed text-center pr-3">
          <SuccessIcon class="text-royal-blue-100">
          </SuccessIcon>
        </div>
        <div class="w-[91.666%] table-cell align-top box-border">
          Authors
        </div>
      </div>
    </div>

    <div>
      <p class="mb-8">
        We will prefill all of the submission fields for you.
      </p>
      <ButtonComponent
        label="OK"
        variant="primary"
        data-testid="acknowledge-manuscript-template-information"
        id="btnModalSave"
        class="w-full md:w-auto"
        @customClick="close"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SuccessIcon from '../ui-components/icons/SuccessIcon.vue'
import { Submission } from '@/types'
import { useStore } from 'vuex'
import ButtonComponent from '../ui-components/ButtonComponent.vue'

const store = useStore()
const emits = defineEmits(['close'])

const extractedTitle = computed((): boolean => {
  return 0 < (store.state.activeSubmission as Submission).title?.length
})

const extractedAbstract = computed((): boolean => {
  return 0 < (store.state.activeSubmission as Submission).abstract?.length
})

const extractedAuthors = computed((): boolean => {
  return 0 < (store.state.activeSubmission as Submission).authors?.length
})

const close = () => {
  emits('close')
}
</script>
